export default "<div>\n    <ng-template dw-dynamic></ng-template>\n</div>\n"